module.exports = __webpack_public_path__ + "static/media/star.34b2e5b5.svg";